const machine = {
    state: {
        isMobile:false
    },
    mutations: {
        set_isMobile(state, boolean) {
            state.isMobile = boolean;
        }
    },
    actions: {
        setIsMobile({commit}, boolean) {
            commit('set_isMobile', boolean);
        }
    }
};
export default machine;
